"use client";

import { useEffect, useState } from "react";

import type { Ad } from "../../types/ads/adResource";
import type { PlaceholderResource } from "../../types/injectables";

import { InjectableNative } from "../Ad/InjectableNative/InjectableNative";
import { getLayout } from "../Ad/utils/helpers";
import { createAdResource } from "../Ad/utils/helpers/createAdResource";
import {
  xandrNativePlacementInFeedSearchMap,
  xandrPlacementInFeedSearchMap,
} from "../Ad/utils/helpers/feedInjectablesMap";

const InjectablePlaceholder = ({
  resource,
}: {
  resource: PlaceholderResource;
}) => {
  const [adResource, setAdResource] = useState<Ad>();
  const [placement, setPlacement] = useState<string | null>(null);

  useEffect(() => {
    const layout = getLayout();
    const placementRule = resource.resource[layout] ?? null;
    const positionFromConfig =
      resource.resource[layout]?.rules?.position ?? null;
    if (
      resource.subType === "xandrNative" ||
      resource.subType === "xandrNativeBackfill"
    ) {
      if (positionFromConfig) {
        const placementWithoutNumber = positionFromConfig.replace(/\d+/g, "");
        setPlacement(placementWithoutNumber);
      }

      if (placement && xandrNativePlacementInFeedSearchMap.has(placement)) {
        const configs = xandrNativePlacementInFeedSearchMap.get(placement);
        if (configs) {
          const adResource = createAdResource({
            ...configs,
            placementRules: placementRule ? [placementRule] : [],
            shouldKeepSizeOnCollapse: false,
            startAsCollapsed: true,
            user: resource.user,
            context: {
              feed: true,
            },
          });
          setAdResource(adResource);
        }
      }
    }
    if (resource.subType === "xandr") {
      if (positionFromConfig) {
        setPlacement(
          positionFromConfig === "newsfeed" ||
            positionFromConfig === "newsfeedDesktop"
            ? "contentDisplay"
            : positionFromConfig,
        );
      }

      if (placement && xandrPlacementInFeedSearchMap.has(placement)) {
        const configs = xandrPlacementInFeedSearchMap.get(placement);
        if (configs) {
          const adResource = createAdResource({
            ...configs,
            placementRules: placementRule ? [placementRule] : [],
            shouldKeepSizeOnCollapse: false,
            startAsCollapsed: false,
            user: {
              isLoggedIn: false,
              isPremium: false,
            },
            context: {
              feed: true,
            },
          });
          setAdResource(adResource);
        }
      }
    }
  }, [resource, placement]);

  if (!adResource) {
    return <div />;
  }

  if (
    placement === "contentDisplay" ||
    placement === "injectableDesktop" ||
    placement === "injectableMobile" ||
    placement === "backFillDesktop" ||
    placement === "backFillMobile"
  ) {
    return <InjectableNative injectableNativeResource={adResource} />;
  }
};

export { InjectablePlaceholder };
